<template>
  <main-layout class="batch-print" page-title="合格证批量补打">
    <div slot="main-content" class="main-content">
      <div class="page">
        <div class="page-header">
          <el-date-picker
            v-model="queryParams.dateArry"
            size="medium"
            type="daterange"
            clearable
            :picker-options="pickerDateOptions"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleChange"
          >
          </el-date-picker>
          <el-select
            v-model="queryParams.origin"
            size="medium"
            @change="handleChange"
          >
            <el-option label="全部合格证类型" :value="null"></el-option>
            <el-option
              v-for="(value, key) in certificate_type"
              :key="key"
              :label="value"
              :value="key"
            />
          </el-select>
          <el-input
            v-model="queryParams.certificateNo"
            size="medium"
            placeholder="请输入合格证编号搜索"
            prefix-icon="el-icon-search"
            @input="handleChangeDebounce"
          />
          <el-input
            v-model.trim="queryParams.productName"
            size="medium"
            placeholder="请输入农产品名称搜索"
            prefix-icon="el-icon-search"
            @input="handleChangeDebounce"
          />
          <div class="right-btn">
            <el-button
              size="medium"
              type="primary"
              plain
              @click="goPage('associatedSite')"
            >
              查看关联站点
            </el-button>
            <el-button
              size="medium"
              type="primary"
              plain
              @click="goPage('printRecord')"
              >打印记录</el-button
            >
          </div>
        </div>
        <el-table
          v-if="!isShowEmpty"
          ref="multipleTable"
          class="page-table"
          empty-text=" "
          v-loading="tableLoading"
          :data="certificateList"
          stripe
          height="calc(100vh - 280px)"
          :row-class-name="TableRow"
          :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
          :cell-style="{ color: '#666666' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            label-class-name="hidden-label"
            width="55"
          />
          <el-table-column label="合格证编号" prop="certificateNo" />
          <el-table-column label="合格证类型" prop="templateName">
            <div slot-scope="scope">
              <span v-if="scope.row.origin">
                {{
                  certificate_type[scope.row.origin].replace("合格证", "") ||
                  "--"
                }}
              </span>
              <span v-if="scope.row.origin === 1">
                - {{ scope.row.templateType === 0 ? "普通" : "绿色认证" }}
              </span>
            </div>
          </el-table-column>
          <el-table-column label="农产品名称">
            <div class="produce-box" slot-scope="scope">
              <img
                class="produceImg"
                :src="scope.row.certificateAttrResp.cropImgUrl"
                alt=""
              />
              <span>{{ scope.row.certificateAttrResp.spmcAttr }}</span>
            </div>
          </el-table-column>
          <el-table-column label="品种来源" prop="farmName">
            <template slot-scope="scope">
              {{
                scope.row.dataOrigin === 1
                  ? "采收库存"
                  : scope.row.dataOrigin === 2
                  ? "外采库存"
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column label="开具数量" prop="certificateAttrResp.zlAttr" />
          <el-table-column
            label="开具时间"
            prop="certificateAttrResp.kjrqAttr"
          />
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="checkInfo(scope.row)"
                >查看</el-button
              >
              <!--              <el-button type="text" @click="printCertificate(scope.row)"-->
              <!--                >补打印合格证</el-button-->
              <!--              >-->
            </template>
          </el-table-column>
        </el-table>
        <div class="noDataImg" v-else>
          <div class="imgNo">
            <img
              src="@/assets/images/aviatFarmingList/batch-nodata.png"
              alt=""
            />
          </div>
          <p style="color: #333; margin-bottom: 20px">未搜索到相关合格证</p>
        </div>
        <el-pagination
          v-if="!isShowEmpty"
          :total="total"
          background
          :current-page="queryParams.pageNo"
          :page-size="queryParams.pageSize"
          @current-change="currentChange"
          @size-change="sizePageChange"
          layout="sizes, total, prev, pager, next"
          :page-sizes="[10, 50, 100, 200, 500, 1000]"
        />
      </div>
      <div class="fixed-bottom">
        <div
          class="select-box"
          :class="[
            isAllSelect && 'is-select',
            isIndeterminate && 'is-indeterminate',
          ]"
          @click="allSelectTable"
        >
          <span class="selectAll"></span>全选
        </div>
        <div>
          <span>
            已选择合格证： {{ selectCertificateLength }} 张 (
            {{ selectCertificateWeight }}公斤 )
          </span>
          <el-button
            size="medium"
            type="primary"
            round
            :disabled="!selectCertificateLength"
            @click="batchPrint(2)"
            >远程补打</el-button
          >
          <el-button
            size="medium"
            type="primary"
            round
            :disabled="!selectCertificateLength"
            @click="batchPrint(1)"
            >本地补打</el-button
          >
        </div>
      </div>
      <el-dialog
        title="查看合格证"
        center
        width="420px"
        :visible.sync="dialogVisible"
        destroy-on-close
        class="view-certificate-dialog"
      >
        <certificate-template
          v-if="dialogVisible"
          :certificateData="selectCertificate"
          :zoom="0.7"
        />
      </el-dialog>
      <el-dialog
        title="多分组打印中"
        class="print-dialog"
        center
        width="790px"
        :visible.sync="printDialogVisible"
      >
        <div class="list-box">
          <div class="list-item" v-for="(item, idx) in printList" :key="idx">
            <div>
              <div class="groupName">分组{{ idx + 1 }}</div>
              <div class="desc" v-if="idx !== printList.length - 1">
                打印第{{ idx * space + 1 }}~{{ idx * space + space }}张
              </div>
              <div
                class="desc"
                v-else-if="printDetailList.length !== idx * space + 1"
              >
                打印第{{ idx * space + 1 }}~{{ printDetailList.length }}张
              </div>
              <div class="desc" v-else>
                打印第{{ printDetailList.length }}张
              </div>
            </div>
            <div class="right-btn">
              <div
                v-if="item.isPrint"
                class="againPrint"
                @click="printFun(idx)"
              >
                再次打印
              </div>
              <div
                class="printBtn"
                :class="[item.isPrint && 'disabled']"
                @click="printFun(idx)"
              >
                打印
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import CertificateTemplate from "@/components/certificateTemplate/index.vue";
import {
  getCertificateList,
  getCertificateListCount,
  getCertificateDetail,
  generateTaskList,
  generatePrintRecordList,
  getCertificateInfoByTask,
  getCertificateDetailList,
  getCertificateStationList,
  getFarmInfo,
  getSnlUrls,
} from "@/api/request/snkd.produce";
// import sameIn from "@/mixins/listsdetails";
import { certificate_type } from "@/confing/map_tab";
import { debounce } from "@/utils";
import { mapActions } from "vuex";
import { Loading } from "element-ui";
import { getStorage, setStorage } from "@/utils/storage";

export default {
  name: "batchPrint",
  // mixins: [sameIn],
  components: {
    MainLayout,
    CertificateTemplate,
  },
  data() {
    return {
      certificate_type,
      certificateList: [],
      selectList: [],
      queryParams: {
        pageNo: 1,
        pageSize: 100,
        certificateNo: "",
        origin: null,
        productName: "",
        printStatus: "",
        dateArry: [],
      },
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      total: 0,
      printDialogVisible: false,
      printList: [],
      space: 100,
      printDetailList: [],
      tableLoading: false,
      dialogVisible: false,
      selectCertificate: {},
      isPrint: false,
      remoteStation: null,
      isShowEmpty: false,
    };
  },
  computed: {
    isGreenCertificate() {
      const key = this.selectCertificate.certificateTemplate?.templateKey;
      return ["dclshgz1", "dclshgz2", "cglshgz12026", "cglshgz12026"].includes(
        key
      );
    },
    isAllSelect() {
      return this.selectList.length === this.certificateList.length;
    },
    isIndeterminate() {
      return (
        this.selectList.length > 0 &&
        this.selectList.length < this.certificateList.length
      );
    },
    selectCertificateLength() {
      return this.selectList.length || 0;
    },
    selectCertificateWeight() {
      return this.selectList.reduce((pre, cur) => {
        let defVal = 0;
        const {
          certificateAttrResp: { zlAttr },
        } = cur;
        if (zlAttr.indexOf("公斤") !== -1) {
          defVal = parseFloat(zlAttr);
        }
        return Number((pre + defVal).toFixed(2));
      }, 0);
    },
  },
  created() {
    this.getFarmInfoFun();
    this.getList();
    this.isPrint = this.hasPermission("produce:certificate:print");
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    getFarmInfoFun() {
      const { companyId, farmId } = getStorage("FARMINFO");
      getFarmInfo({
        companyId,
        farmId,
      }).then((res) => {
        if (res.respCode === 0) {
          setStorage("FARMINFO", res.obj.farmDetailVO);
        }
      });
    },
    getList() {
      this.tableLoading = true;
      const params = {
        ...this.queryParams,
        printStatus: 1,
        templateKeys: [
          "dcpthgz",
          "dclshgz1",
          "dclshgz2",
          "wchgz",
          "schgz",
          "dcpthgz2026",
          "dclshgz12026",
          "dclshgz22026",
          "cgpthgz2026",
          "cglshgz12026",
          "cglshgz22026",
          "schgz2026",
        ],
      };
      if (this.queryParams.dateArry) {
        params["startDate"] = this.queryParams.dateArry[0] || "";
        params["endDate"] = this.queryParams.dateArry[1] || "";
      }
      getCertificateList(params).then(({ obj }) => {
        this.certificateList = obj ? obj.list : [];
        this.tableLoading = false;
        this.isShowEmpty = !this.certificateList.length;
      });
      getCertificateListCount(params).then(({ obj }) => {
        this.total = obj;
      });
    },
    //设置表格行的样式
    TableRow({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "statistics-warning-row";
      } else {
        return "";
      }
    },
    // 输入框input 防抖
    handleChangeDebounce: debounce(async function () {
      this.queryParams.pageNo = 1;
      await this.getList();
    }),
    // 选择日期类型 chang方法
    handleChange() {
      this.queryParams.pageNo = 1;
      this.getList();
    },
    goPage(page) {
      this.$router.push({
        path: `/Certificate/${page}`,
      });
    },
    // 查看按钮
    async checkInfo(row) {
      const { certificateId, certificateNo } = row;
      // 判断神农链url 是否生成完全；
      const result = await getSnlUrls({
        certificateNoList: [certificateNo],
      });
      if (result.respCode !== 0) {
        return false;
      }
      getCertificateDetail({ certificateId, certificateNo }).then((res) => {
        this.selectCertificate = res.obj;
        this.dialogVisible = true;
        console.log("this.selectCertificate", this.selectCertificate);
      });
    },
    // 补打印合格证
    printCertificate(row) {
      const { certificateId, certificateNo } = row;
      getCertificateDetail({ certificateId, certificateNo }).then((res) => {
        this.$print({
          list: [res.obj],
        });
      });
    },
    async batchPrint(printType) {
      const loading = Loading.service({
        lock: true,
        text: "数据请求中…",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let stationInfo;
      if (printType === 2) {
        stationInfo = await this.getRemoteStation();
        if (!stationInfo.stationId) {
          this.$message.warning("暂未关联站点，请在神农口袋APP端扫码关联");
          return;
        }
      }
      const selects = [...this.selectList];
      // 判断神农链url 是否生成完全；
      const result = await getSnlUrls({
        certificateNoList: selects.map((i) => i.certificateNo),
      });
      if (result.respCode !== 0) {
        loading.close();
        return false;
      }
      const { obj } = await generateTaskList({
        certificateNos: selects.map((i) => i.certificateNo),
      });
      console.log("obj", obj, printType);
      const params = {
        stationId: 0,
        taskBatchId: obj,
        taskPrintInfoDTO: {
          totalNum: this.selectCertificateLength,
          totalWeight: this.selectCertificateWeight,
        },
        taskType: printType,
      };
      if (printType === 2) {
        params.stationId = stationInfo.stationId;
        await generatePrintRecordList(params);
        this.$router.push({
          path: "/operateCompleted?from=remote",
        });
        loading.close();
        return false;
      }
      await generatePrintRecordList(params);
      const resp = await getCertificateInfoByTask({
        taskBatchId: obj,
        pageSize: 10000,
      });
      const certificateIds = resp.obj.list.map((i) => i.certificateId);
      this.grounpPrint(certificateIds);
      this.selectList = [];
      this.$refs.multipleTable.clearSelection();
      loading.close();
    },
    async grounpPrint(certificateIds) {
      if (certificateIds.length > 1) {
        this.printDetailList = certificateIds;
        const list = [];
        const arrLength = Math.ceil(certificateIds.length / this.space);
        for (let i = 0; i < arrLength; i++) {
          list.push({ isPrint: false });
        }
        this.printList = list;
        this.printDialogVisible = true;
      } else {
        const res = await getCertificateDetailList({ certificateIds });
        this.$print({
          list: res.obj,
          callback: (status) => {
            console.log("打印状态" + status); // 1是组装数据成功 2：打印预览关闭
          },
        });
      }
    },
    async printFun(idx) {
      this.printList[idx].isPrint = true;
      const certificateIds = this.printDetailList.slice(
        idx * this.space,
        idx * this.space + this.space
      );
      const res = await getCertificateDetailList({ certificateIds });
      this.$print({
        list: res.obj,
        callback: (status) => {
          console.log("打印状态" + status); // 1是组装数据成功 2：打印预览关闭
        },
      });
    },
    // 单选
    handleSelectionChange(rows) {
      this.selectList = rows;
    },
    // 全选按钮操作
    allSelectTable() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 页码单选
    currentChange(page) {
      this.queryParams.pageNo = page;
      this.getList();
    },
    // 分页数量
    sizePageChange(pages) {
      this.queryParams.pageNo = 1;
      this.queryParams.pageSize = pages;
      this.getList();
    },
    async getRemoteStation() {
      const { obj } = await getCertificateStationList({});
      let remoteStation = {};
      if (obj && obj.length) {
        remoteStation = obj.filter((i) => i.defaultChoose)[0];
      }
      return remoteStation;
    },
  },
};
</script>

<style scoped lang="scss">
.batch-print {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .page {
      min-height: 0;
      flex: 1;
      padding: 20px;
      &-header {
        display: flex;
        & > div {
          width: 190px;
          margin-right: 10px;
        }
        .right-btn {
          margin-left: auto;
          margin-right: 0;
          width: auto;
        }
        ::v-deep .el-date-editor--daterange {
          width: 250px;
        }
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
        }
        input[type="number"] {
          -moz-appearance: textfield;
        }
      }
      &-table {
        margin-top: 10px;
        ::v-deep .hidden-label {
          opacity: 0;
        }
        .produce-box {
          display: flex;
          align-items: center;
          .produceImg {
            width: 35px;
            height: 35px;
            margin-right: 10px;
          }
        }
        ::v-deep .el-checkbox__inner {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          &::after {
            width: 4.5px;
            height: 10.5px;
            top: 1.5px;
            left: 6px;
            border-width: 1.5px;
          }
          &::before {
            height: 3px;
            top: 8.5px;
          }
        }
      }
      ::v-deep .el-pagination {
        text-align: right;
        margin-top: 10px;
      }
      ::v-deep .el-table td,
      ::v-deep .el-table th.is-leaf {
        border: none;
      }
    }
    .fixed-bottom {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      padding: 18px 30px;
      box-sizing: border-box;
      box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.04);
      z-index: 1;
      .select-box {
        cursor: pointer;
        outline: 0;
        line-height: 1;
        vertical-align: middle;
        display: flex;
        align-items: center;
        &.is-indeterminate {
          .selectAll {
            background-color: #64c3a4;
            border-color: #64c3a4;
            &::before {
              content: "";
              position: absolute;
              display: block;
              background-color: #fff;
              height: 3px;
              transform: scale(0.5);
              left: 0;
              right: 0;
              top: 8.5px;
            }
          }
        }
        &.is-select {
          .selectAll {
            background-color: #64c3a4;
            border-color: #64c3a4;
            &::after {
              transform: rotate(45deg) scaleY(1);
            }
          }
        }
        .selectAll {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          display: inline-block;
          position: relative;
          border: 1px solid #dcdfe6;
          box-sizing: border-box;
          background-color: #fff;
          z-index: 1;
          margin-right: 10px;
          transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
            background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
          &::after {
            box-sizing: content-box;
            content: "";
            border: 1.5px solid #ffffff;
            border-left: 0;
            border-top: 0;
            height: 10.5px;
            left: 6px;
            position: absolute;
            top: 1.5px;
            transform: rotate(45deg) scaleY(0);
            width: 4.5px;
            transition: transform 0.15s ease-in 0.05s;
            transform-origin: center;
          }
        }
      }
    }
  }
  .view-certificate-dialog {
    ::v-deep .el-dialog {
      .el-dialog__header {
        border-bottom: 1px solid #eeeeee;
      }
    }
  }
  .print-dialog {
    ::v-deep .el-dialog {
      border-radius: 10px;
      .el-dialog__header {
        border-radius: 10px 10px 0 0;
        background-color: #64c3a4;
        color: #fff;
        padding: 15px 20px;
        .el-dialog__title,
        .el-dialog__close {
          color: #fff;
        }
      }
      .el-dialog__body {
        padding: 0;
        max-height: 500px;
        overflow-y: auto;
      }
    }
    .list-box {
      padding: 24px;
    }
    .list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      border-radius: 20px;
      background: #fff;
      box-shadow: 0px 5px 20px 0px rgba(85, 85, 124, 0.13);
      margin-bottom: 20px;
      padding: 15px 24px;
      box-sizing: border-box;
    }
    .groupName {
      color: #333;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .desc {
      color: #b2b2b2;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 12px;
    }
    .right-btn {
      display: flex;
      align-items: center;
    }
    .printBtn {
      width: 68px;
      height: 32px;
      line-height: 32px;
      flex-shrink: 0;
      border-radius: 30px;
      border: 1px solid #64c3a4;
      background: #eefff9;
      color: #64c3a4;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      margin-left: 16px;
      cursor: pointer;
    }
    .printBtn.disabled {
      border-color: #d9d9d9;
      color: #d9d9d9;
      background: #fff;
      pointer-events: none;
    }
    .againPrint {
      color: #64c3a4;
      text-align: right;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      cursor: pointer;
    }
  }
}
</style>
